import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetContentHealthResponse } from './get-content-health-response';
import { getContentHealthResponseSchema } from './get-content-health-response';

export async function getContentHealthApi(): Promise<
  IValidatedResponse<IGetContentHealthResponse>
> {
  return getRequest<IGetContentHealthResponse>({
    path: '/sys/monitoring/content',
    schema: getContentHealthResponseSchema,
  });
}
